import type en from "../en/shell";
import type { Translation } from "../../types";

const shell: Translation<typeof en> = {
  routeError: {
    title: "Un problème est survenu sur cette page",
    body: "Le reste de l’application fonctionne toujours. Rechargez pour réessayer cette page — si cela se reproduit, dites-nous ce que vous faisiez.",
    reload: "Recharger la page",
    home: "Aller à la bibliothèque",
  },
  nav: {
    home: "Accueil",
    library: "Bibliothèque",
    studio: "Studio",
    search: "Recherche",
    people: "Membres",
    settings: "Paramètres",
    account: "Votre compte",
    backOffice: "Back-office",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    signOut: "Se déconnecter",
  },
  theme: {
    light: "Thème clair",
    dark: "Thème sombre",
    system: "Thème du système",
  },
  workspace: {
    select: "Choisir un espace de travail",
    noneTitle: "Aucun espace de travail",
    noneBody:
      "Votre compte ne fait partie d’aucun espace de travail. Si vous avez été invité, ouvrez le lien figurant dans votre e-mail d’invitation.",
    chooseTitle: "Choisissez un espace de travail",
    chooseBody: "Votre compte appartient à plusieurs espaces de travail.",
  },
  toast: {
    dismiss: "Fermer",
  },
  errorState: {
    title: "Un problème est survenu",
    body: "Impossible de charger ce contenu.",
  },
  http: {
    unauthorized: "Votre session a expiré. Reconnectez-vous.",
    forbidden: "Vous n’avez pas l’autorisation de faire cela.",
    notFound: "Cet élément n’existe plus.",
    tooManyRequests: "Trop de requêtes. Patientez un instant et réessayez.",
    server: "Un problème est survenu de notre côté. Réessayez dans un instant.",
    rejected: "Cette requête n’a pas été acceptée.",
  },
};

export default shell;
